define('viewModels/privileged/qm/CreateEvaluationView',[
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/policies/editors/AgentSelectorView',
    'viewModels/privileged/qm/policies/editors/EvaluationFormSelectorView',
    'viewModels/privileged/qm/util/ServiceResponseValidator',
    'viewModels/privileged/composer/forms/formEditor/Evaluation',
    'services/qualityManagementService',
    'services/qm/qualityAuth',
    'services/userService',
    'services/composer/evaluationFormService',
    'services/queuesService',
    'services/authService',
    'services/toastService',
    'util/errorCallbackFactory'
], function (_,
             ko,
             Promise,
             ViewModel,
             AgentSelectorView,
             EvaluationFormSelectorView,
             ServiceResponseValidator,
             EvaluationView,
             qualityService,
             qualityAuthorization,
             userService,
             evaluationFormService,
             queueService,
             authService,
             toasts,
             errorCallbackFactory) {
    'use strict';

    var CreateEvaluationView = ViewModel.extend(function (conversationObservable, newEvaluationCallback, cancelCreateEvaluationCallback, createCalibrationCallback) {
        var self = this;
        self.selectedForm = ko.observable(null);
        self.expertEvaluator = ko.observable(null);
        self.evaluationView = ko.observable();
        var conversationId;
        self.saving = ko.observable(false);
        self.loading = ko.observable(true);
        self.loadingEvaluationForm = ko.observable(false);

        self.useAsCalibrationRadioGroupValue = ko.observable(false);
        self.isExpertEvaluation = ko.observable(false);
        self.agentOnInteraction = ko.observable();
        self.queueOnInteraction = ko.observable();
        self.internalAgents = ko.observableArray([]);
        self.queuesForConversation = ko.observableArray();
        self.canAddCalibration = qualityAuthorization.canAddCalibration();
        self.missingParticipatePermission = ko.observable(null);
        var responseValidator = new ServiceResponseValidator();
        self.selectedEvaluator = ko.observable(null).extend({responseValidator: responseValidator});
        self.calibrationEvaluators = ko.observableArray([]).extend({responseValidator: responseValidator});

        self.subscribe(self.useAsCalibrationRadioGroupValue, function (newVal) {
            // Reset values and validation for evaluators when the calibration radio is changed.
            if (newVal) {
                self.selectedEvaluator(null);
                self.selectedEvaluator.isModified(false);
                self.missingParticipatePermission(null);
            } else {
                self.calibrationEvaluators([]);
                self.calibrationEvaluators.isModified(false);
                self.missingParticipatePermission(null);
            }
        });

        var queueAndUser;
        var buildQueueAndUser = function(participants) {

            function mapUserIdToQueues(userId) {
                return _.compact(_.map(_.filter(participants, {userId: userId}), 'queueId'));
            }

            function expandQueues() {
                var queueIds = _.chain(participants)
                        .map('queueId')
                        .compact()
                        .uniq()
                        .value();
                return queueService.getQueuesBrief({pageSize: 100, id: queueIds})
                    .then(function(response) {
                        var briefQueues = response.entities;
                        var briefQueueIds = _.map(briefQueues, function(queue) {
                            return queue.id;
                        });
                        var missingQueueIds = _.difference(queueIds, briefQueueIds);
                        var results = _.map(briefQueues, function(briefQueue) {
                            return {
                                id: briefQueue.id,
                                name: briefQueue.name
                            };
                        });
                        return _.union(results, _.map(missingQueueIds, function(missingQueueId) {
                            return {
                                id: missingQueueId,
                                name: ko.i18n.renderString("evaluation.noQueueName")
                            };
                        }));
                    });
            }

            function expandUser(participant)  {
                return userService.getUser(participant.userId)
                    .then(function(result){
                        return {
                            id: result.id,
                            displayName: result.name
                        };
                    })
                    .catch(function (e) {
                        errorCallbackFactory.createCallback({namespace: "evaluation.userOrQueueError"})(e);
                        return {
                            id: participant.userId,
                            displayName: ko.i18n.renderString("evaluation.noAgentName")
                        };
                    });
            }

            return {

                /**
                 * gets all of the queues and returns them
                 * @returns {Array}
                 */
                getQueues: function() {
                    //todo: apiFix so that we don't always have to expand queues
                    return expandQueues();
                },

                /**
                 * gets the users and if necessary, expands userIds
                 * @returns {Promise}
                 */
                getUsers: function() {
                    return Promise.all(
                        _.chain(participants)
                            .filter(function(participant){
                                return participant.purpose && (participant.purpose.toLowerCase() === 'user' || participant.purpose.toLowerCase() === 'agent');
                            })
                            .uniqBy('userId')
                            .map(function(participant) {
                                if (!participant.userId && !_.isEmpty(participant.name)){
                                    return Promise.resolve().then(function(){
                                        return {
                                            id: participant.userId,
                                            displayName: participant.name
                                        };
                                    });
                                } else {
                                    return expandUser(participant);
                                }
                            })
                            .compact()
                            .value()
                    );
                },

                findCorrectQueues: function(userId, queues) {
                    var queueIds = mapUserIdToQueues(userId);
                    return _.chain(queues)
                            .filter(function(queue){
                                return _.includes(queueIds, queue.id);
                            })
                            .value();
                }
            };
        };

        self.subscribe(self.internalAgents, function () {
            if (self.internalAgents() && self.internalAgents().length === 1) {
                self.agentOnInteraction(self.internalAgents()[0]);
                self.missingParticipatePermission(null);
            }
        });

        self.computed(function () {
            var conversation = ko.toJS(conversationObservable);
            if (conversation) {
                queueAndUser = buildQueueAndUser(conversation.participants);
                conversationId = conversation.id;

                var usersPromise = queueAndUser.getUsers()
                    .then(function(result){
                        if (!_.isEmpty(result)){
                            self.internalAgents(_.uniq(result, 'id'));
                        }
                    });

                var queuesPromise = queueAndUser.getQueues()
                    .then(function(values){
                        if (!_.isEmpty(values)){
                            self.queuesForConversation(values);
                        }
                    });

                Promise.all([usersPromise, queuesPromise])
                    .catch(errorCallbackFactory.createCallback({namespace: "evaluation.userOrQueueError"}))
                    .finally(function(){
                        self.loading(false);
                    });
            }
        });

        self.queuesForAgent = self.computed(function () {
            if (self.agentOnInteraction() && queueAndUser) {
                 return queueAndUser.findCorrectQueues(self.agentOnInteraction().id, self.queuesForConversation());
            } else {
                return self.queuesForConversation();
            }
        });

        self.subscribe(self.queuesForAgent, function () {
            if (self.queuesForAgent().length === 1) {
                self.queueOnInteraction(self.queuesForAgent()[0]);
            } else if (self.queuesForAgent().length === 0) {
                self.queueOnInteraction(null);
            }
        });

        self.evaluationFormSelector = self.subView(EvaluationFormSelectorView, self.selectedForm);

        self.evaluatorSelector = self.subView(AgentSelectorView, self.selectedEvaluator);
        self.calibrationEvaluatorsSelector = self.subView(AgentSelectorView, self.calibrationEvaluators);

        self.expertEvaluatorSelector = self.subView(AgentSelectorView, self.expertEvaluator);

        self.hasMultipleAgents = self.computed(function(){
            return self.internalAgents() && self.internalAgents().length > 1;
        });

        //convenience method for single agents
        self.hasSingleAgent = self.computed(function(){
            return self.internalAgents() && self.internalAgents().length === 1 &&
                self.agentOnInteraction() && self.agentOnInteraction().displayName;
        });

        self.hasMultipleQueues = self.computed(function(){
            return self.queuesForConversation() && self.queuesForConversation().length > 1;
        });

        self.hasSingleQueue = self.computed(function(){
            return self.queuesForConversation() && self.queuesForConversation().length === 1 &&
                self.queueOnInteraction() && self.queueOnInteraction().name;
        });

        self.save = function() {
            var selectedForm = self.selectedForm();
            var selectedEvaluator = self.selectedEvaluator();
            var selectedAgent = self.agentOnInteraction();
            var selectedQueue = self.queueOnInteraction();
            var expertEvaluator = self.expertEvaluator();
            var useAsCalibration = ko.unwrap(self.useAsCalibrationRadioGroupValue);
            var isExpertEvaluation = self.isExpertEvaluation();
            if (self.internalAgents()) {
                if (useAsCalibration) {

                    var calibration = {
                        calibrator: { id: authService.principalId() },
                        conversation: { id: conversationId },
                        agent: { id: selectedAgent.id}
                    };

                    var calibrationEvaluators = ko.unwrap(self.calibrationEvaluators);
                    calibration.evaluators = _.map(calibrationEvaluators, function (evaluator) {
                        return {
                            id: evaluator.id
                        };
                    });

                    calibration.evaluationForm = selectedForm;
                    if (isExpertEvaluation) {
                        calibration.expertEvaluator = { id: expertEvaluator.id };
                    }

                    self.saving(true);
                    qualityService.createCalibration(calibration)
                    .then(function(response) {
                        responseValidator.handleSuccess();
                        createCalibrationCallback(response);
                    })
                    .catch(function(err) {
                        if (err &&
                            err.details &&
                            err.details.response &&
                            err.details.response.code === "quality.evaluation.agent.doesnt.have.participate.permission") {
                            return self.handleMissingPartcipatePermission();
                        } else {
                            return responseValidator.createErrorCallback({ namespace: 'calibration.createCalibrationRequest' })(err);
                        }
                    })
                    .finally(function () {
                        self.saving(false);
                    });

                } else {
                    var evaluation = {
                        evaluationForm: selectedForm,
                        evaluator: { id: selectedEvaluator.id },
                        conversation: {  id: conversationId  }
                    };

                    if (selectedAgent && selectedAgent.id){
                        evaluation.agent = { id: selectedAgent.id};
                    }

                    if (selectedQueue && selectedQueue.id){
                        evaluation.queue = { id: selectedQueue.id };
                    }

                    self.saving(true);
                    qualityService.createEvaluation(evaluation)
                    .then(function(response) {
                        responseValidator.handleSuccess();
                        // evaluator name is used in PlaybackView for a notification;
                        // passing along evaluator this way to avoid another server lookup
                        response.evaluator = self.selectedEvaluator();
                        newEvaluationCallback(response);
                    })
                    .catch(function(err) {
                        if (err &&
                            err.details &&
                            err.details.response &&
                            err.details.response.code === "quality.evaluation.agent.doesnt.have.participate.permission") {
                            return self.handleMissingPartcipatePermission();
                        } else {
                            return responseValidator.createErrorCallback({ namespace: 'evaluation.createEvaluationRequest' })(err);
                        }
                    })
                    .finally(function () {
                        self.saving(false);
                    });
                }
            } else {
                toasts.notifyMajorAlert('playback.nav.evaluation.new.missing.agent');
            }
        };

        self.computed(function () {
            if (self.evaluationView()) {
                self.evaluationView().dispose();
                self.evaluationView(null);
            }
        });

        self.removeActiveTab = function() {
            cancelCreateEvaluationCallback();
        };

        self.onDispose = function () {
            if (self.evaluationView()) {
                self.evaluationView().dispose();
                self.evaluationView(null);
            }
        };

        self.handleMissingPartcipatePermission = function () {
            var agentMissingParticipate = self.agentOnInteraction().displayName;
            var result = "";
            if (agentMissingParticipate) {
                result = ko.i18n.renderString('evaluation.agentIDMissingParticipate', {
                    value: agentMissingParticipate
                });
            } else {
                result = ko.i18n.renderString('evaluation.agentMissingParticipate');
            }
            self.missingParticipatePermission(result);
        };

        self.resetError = function() {
            self.missingParticipatePermission(null);
        };
    });
    return CreateEvaluationView;
});

